// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ClientApps = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ClientApps = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ClientApps = _exports.ClientApps = function ClientApps(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 21 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "9.99935",
      cy: "10.0003",
      r: "3.33333",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "10.0002",
      cy: "10.0002",
      r: "8.05556",
      stroke: "currentColor",
      "stroke-width": "1.66667"
    }), /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "4.44488",
      cy: "3.33355",
      r: "2.22222",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "7.77886",
      cy: "17.7779",
      r: "2.22222",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "17.7789",
      cy: "7.77789",
      r: "2.22222",
      fill: "currentColor"
    }));
  };
});
